import React, { useState, useEffect } from 'react';
import axios from 'axios';
function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }
const PLANS = { free:{color:'#64748b',bg:'#f1f5f9'}, pro:{color:'#1d4ed8',bg:'#dbeafe'}, enterprise:{color:'#7c3aed',bg:'#ede9fe'}, msp:{color:'#d97706',bg:'#fef3c7'} };

export default function Organizations({ user }) {
  const [orgs, setOrgs] = useState([]);
  const [stats, setStats] = useState(null);
  const [msg, setMsg] = useState({ text:'', type:'' });
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name:'', slug:'', plan:'enterprise', adminEmail:'' });
  const [saving, setSaving] = useState(false);

  function flash(t,type='success') { setMsg({text:t,type}); setTimeout(()=>setMsg({text:'',type:''}),4000); }
  useEffect(()=>{
    axios.get('/api/orgs',auth()).then(r=>setOrgs(r.data)).catch(()=>{});
    axios.get('/api/orgs/current',auth()).then(r=>{ if(r.data?.id) return axios.get(`/api/orgs/${r.data.id}/stats`,auth()); }).then(r=>r&&setStats(r.data)).catch(()=>{});
  },[]);

  async function save(e) {
    e.preventDefault(); setSaving(true);
    try { await axios.post('/api/orgs',form,auth()); flash('Organization created'); setShowForm(false); const r=await axios.get('/api/orgs',auth()); setOrgs(r.data); }
    catch(e) { flash(e.response?.data?.error||'Failed','error'); } finally { setSaving(false); }
  }

  return (
    <div style={{padding:24}}>
      {msg.text&&<div style={{padding:'10px 16px',borderRadius:8,marginBottom:16,background:msg.type==='error'?'#fee2e2':'#dcfce7',color:msg.type==='error'?'#dc2626':'#16a34a',fontWeight:600}}>{msg.type==='error'?'✘':'✔'} {msg.text}</div>}
      <div style={{display:'flex',justifyContent:'space-between',marginBottom:24}}>
        <div><h2 style={{margin:0,fontSize:20,fontWeight:700}}>Organizations</h2><p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>Multi-tenant management — isolate device fleets per organization (MSP mode)</p></div>
        <button onClick={()=>setShowForm(true)} style={{background:'#1e40af',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontWeight:600,cursor:'pointer'}}>+ New Organization</button>
      </div>
      {stats&&(
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))',gap:12,marginBottom:24}}>
          {[['Total Devices',stats.devices?.total,'🖥','#1e40af'],['Online',stats.devices?.online,'◉','#16a34a'],['Patch Success',`${stats.patches?.successRate||0}%`,'⊞','#7c3aed'],['Critical Vulns',stats.vulnerabilities?.critical||0,'⚠','#dc2626']].map(([l,v,icon,c])=>(
            <div key={l} style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:10,padding:'14px 16px'}}>
              <div style={{fontSize:22,fontWeight:800,color:c}}>{v??'—'}</div>
              <div style={{fontSize:12,color:'#64748b'}}>{l}</div>
            </div>
          ))}
        </div>
      )}
      {orgs.length===0 ? <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}><div style={{fontSize:40}}>🏢</div><div style={{fontWeight:600,marginTop:12}}>No organizations yet</div></div> : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))',gap:14}}>
          {orgs.map(org=>{
            const pm = PLANS[org.plan]||PLANS.enterprise;
            return (
              <div key={org.id} style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,padding:18}}>
                <div style={{display:'flex',justifyContent:'space-between',marginBottom:10}}>
                  <div><div style={{fontWeight:700,fontSize:15}}>{org.name}</div><div style={{fontSize:12,color:'#64748b'}}>/{org.slug}</div></div>
                  <span style={{background:pm.bg,color:pm.color,borderRadius:5,padding:'2px 8px',fontSize:11,fontWeight:700,textTransform:'uppercase'}}>{org.plan}</span>
                </div>
                <div style={{fontSize:12,color:'#64748b',marginBottom:12}}>
                  <div>Admin: {org.adminEmail||'—'}</div>
                  <div>Devices: {org.deviceCount||0} · Status: {org.active?'Active':'Inactive'}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {showForm&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:460,maxWidth:'95vw'}}>
            <h3 style={{margin:'0 0 20px',fontSize:18,fontWeight:700}}>New Organization</h3>
            <form onSubmit={save}>
              {[['Name*','name'],['Slug*','slug','url-safe identifier, e.g. covasant'],['Admin Email','adminEmail','']].map(([l,k,ph])=>(
                <div key={k} style={{marginBottom:14}}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>{l}</label>
                  <input value={form[k]||''} onChange={e=>setForm({...form,[k]:e.target.value})} required={l.includes('*')} placeholder={ph} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} /></div>
              ))}
              <div style={{marginBottom:20}}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Plan</label>
                <select value={form.plan} onChange={e=>setForm({...form,plan:e.target.value})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14}}>
                  {Object.keys(PLANS).map(p=><option key={p} value={p}>{p.charAt(0).toUpperCase()+p.slice(1)}</option>)}
                </select></div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button type="button" onClick={()=>setShowForm(false)} style={{padding:'10px 20px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
                <button type="submit" disabled={saving} style={{padding:'10px 20px',background:saving?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:saving?'default':'pointer'}}>{saving?'Creating...':'Create'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
